export const UserAskedToReadItem = "user_askedtoread_item";
export const UserReadItem = "user_read_item";
export const UserAllOrgReadItem = "user_all_org_read_item";
export const UserUnReadItem = "user_unread_item";